module.exports = __webpack_public_path__ + "static/media/sign4.7b76bb9d.png";